module.exports = __webpack_public_path__ + "static/3dview-136f5c11ee48ba09ebc5f04d4e962542.mp4";